// Resource-card action buttons — extracted from snippets/resource-card.liquid so
// it loads ONCE per page instead of being inlined per card (28 cards on the
// homepage inlined ~10.8KB each ≈ 285KB of duplicated HTML + re-parsed markup).
// The logic is document-delegated and self-guarded, so a single global load
// covers every card on the page, including cards injected later via the Section
// Rendering API / quick view. Loaded from snippets/scripts.liquid (defer).
(function () {
  // Card action buttons: "Buy sample" adds the product's Sample variant to the
  // cart (same contract as the PDP), and "Add to wishlist" forwards to the
  // WishlistHero control. Both flash a checkmark on success. Bound once via
  // delegation, however many cards are on the page.
  if (window.__rcActions) return;
  window.__rcActions = true;

  // WP-20-11 — reflect WishlistHero state: filled heart + "Remove from wishlist"
  // label on products already in the wishlist. Detected from WishlistHero's
  // localStorage (key/shape varies, so we match defensively) and confirmed by
  // the WishlistHero control's own class where present.
  function setWishlistVisual(card, on) {
    if (!card) return;
    card.querySelectorAll('[data-rc-wishlist], [data-rc-wishlist-proxy]').forEach(function (el) {
      el.classList.toggle('is-wishlisted', !!on);
      var label = el.querySelector('[data-rc-label]');
      if (label) {
        var base = on
          ? 'Added'
          : (el.hasAttribute('data-rc-wishlist-proxy') ? 'Add to wishlist' : 'Wishlist');
        label.setAttribute('data-rc-label', base);
        if (!el.classList.contains('is-loading') && !el.classList.contains('is-success')) {
          label.textContent = base;
        }
      }
      if (el.hasAttribute('data-rc-wishlist')) {
        el.setAttribute('aria-label', on ? 'Added to wishlist' : 'Add to wishlist');
      }
    });
  }

  function wishlistBlob() {
    var blob = '';
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && /wishlist|swym|wlh/i.test(k)) blob += '\n' + (localStorage.getItem(k) || '');
      }
    } catch (e) {}
    return blob;
  }

  function isWishlisted(wrap, blob) {
    var ctrl = wrap.querySelector('.wishlisthero-floating, .wishlist-hero-custom-button');
    if (ctrl && /in-wishlist|in_wishlist|wishlisted|is-added|active/i.test(ctrl.className)) return true;
    var pid = wrap.getAttribute('data-rc-product-id');
    if (pid && new RegExp('(^|[^0-9])' + pid + '([^0-9]|$)').test(blob)) return true;
    var handle = (wrap.getAttribute('data-rc-product-handle') || '').toLowerCase();
    if (handle) {
      var b = blob.toLowerCase();
      if (b.indexOf('"' + handle + '"') !== -1 || b.indexOf('/' + handle) !== -1) return true;
    }
    return false;
  }

  // WishlistHero persists its storage asynchronously (a server round-trip), so for a
  // few hundred ms after a toggle a state read still returns the OLD value — which was
  // reverting the optimistic flip and leaving the heart looking unchanged until a page
  // reload (item 5). After a toggle we "pin" the shopper's intended state on the wrap so
  // the reconcile can only re-affirm it, never contradict it, until WLH has caught up.
  var WISH_PIN_MS = 8000;
  function pinWishlist(wrap, expected) {
    if (!wrap) return;
    wrap.__rcWishExpect = expected;
    wrap.__rcWishPinUntil = Date.now() + WISH_PIN_MS;
    // Sync with the authoritative WLH state once the pin lapses (covers a failed add or
    // a change made elsewhere) — by then WLH has persisted, so detection is reliable.
    setTimeout(refreshWishlistState, WISH_PIN_MS + 400);
  }

  function refreshWishlistState() {
    var blob = wishlistBlob();
    var now = Date.now();
    document.querySelectorAll('[data-rc-wishlist]').forEach(function (wrap) {
      var on = (wrap.__rcWishPinUntil && now < wrap.__rcWishPinUntil)
        ? wrap.__rcWishExpect
        : isWishlisted(wrap, blob);
      setWishlistVisual(wrap.closest('.resource-card'), on);
    });
  }

  function startLoading(el) {
    clearTimeout(el.__rcTimer);
    el.classList.remove('is-success');
    el.classList.add('is-loading');
  }

  function flashSuccess(el, successLabel) {
    el.classList.remove('is-loading');
    el.classList.add('is-success');
    var label = el.querySelector('[data-rc-label]');
    if (label && successLabel) label.textContent = successLabel;
    clearTimeout(el.__rcTimer);
    el.__rcTimer = setTimeout(function () {
      el.classList.remove('is-success');
      if (label) label.textContent = label.getAttribute('data-rc-label');
    }, 1800);
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  }

  // Mirror the cart:update payload Horizon's product-form dispatches, so the
  // cart icon updates, the drawer re-renders from `sections`, and (if it has
  // auto-open) the drawer opens.
  function fireCartUpdate(cart, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'resource-card',
        data: { source: 'resource-card', itemCount: cart && cart.item_count, sections: sections }
      }
    }));
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addSample(variantId, btn) {
    // Dedup: if this sample is already in the cart, just surface the drawer.
    return getJSON('/cart.js').then(function (cart) {
      var inCart = cart.items && cart.items.some(function (it) {
        return String(it.variant_id) === String(variantId);
      });
      if (inCart) {
        fireCartUpdate(cart, null);
        flashSuccess(btn, 'Added');
        return;
      }
      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      var sections = cartSectionIds();
      if (sections) body.append('sections', sections);
      return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'text/html' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (added) {
          if (!added || added.status) return; // add failed
          return getJSON('/cart.js').then(function (newCart) {
            fireCartUpdate(newCart, added.sections);
            flashSuccess(btn, 'Added');
          });
        });
    }).catch(function () {});
  }

  function triggerWishlist(wrap) {
    if (wrap.classList.contains('is-loading')) return;
    // The control may not be mounted yet: wild-wishlist-defer.js hydrates on approach, and
    // a card can be clicked in the same frame it appears. Mount it now — a no-op once it
    // already is — so the click below always has something to hit.
    if (window.WPWishlistDefer) window.WPWishlistDefer.hydrateWithin(wrap);
    var ctrl = wrap.querySelector('.wishlisthero-floating, .wishlist-hero-custom-button');
    var target = ctrl && ctrl.querySelector('button, a, [role="button"]');
    var card = wrap.closest('.resource-card');
    // Optimistic flip (WP-20-11); pin the intended state so the reconcile below can't
    // revert it while WLH is still persisting (item 5), then reconcile with storage.
    var willBe = !wrap.classList.contains('is-wishlisted');
    setWishlistVisual(card, willBe);
    pinWishlist(wrap, willBe);
    startLoading(wrap);
    if (target) target.click();
    else if (ctrl) {
      // A just-hydrated control can need a frame before its inner button exists. Wait for
      // it rather than clicking the empty holder, which would do nothing — and activate
      // exactly ONE of the two, since clicking both would toggle the item on and straight
      // back off.
      requestAnimationFrame(function () {
        var late = ctrl.querySelector('button, a, [role="button"]');
        (late || ctrl).click();
      });
    }
    // WishlistHero gives no completion signal, so hold the loader briefly,
    // then confirm.
    setTimeout(function () { flashSuccess(wrap, 'Added'); }, 550);
    setTimeout(refreshWishlistState, 400);
    setTimeout(refreshWishlistState, 1200);
  }

  // Mobile menu's wishlist item forwards to the card's single WishlistHero
  // control (kept in the hidden desktop action row) so we never render a
  // duplicate WishlistHero control per card.
  function proxyWishlist(proxyBtn) {
    if (proxyBtn.classList.contains('is-loading')) return;
    var card = proxyBtn.closest('.resource-card');
    var wrap = card && card.querySelector('[data-rc-wishlist]');
    var willBe = !(wrap && wrap.classList.contains('is-wishlisted'));
    setWishlistVisual(card, willBe);
    pinWishlist(wrap, willBe);
    startLoading(proxyBtn);
    if (wrap) {
      var ctrl = wrap.querySelector('.wishlisthero-floating, .wishlist-hero-custom-button');
      var target = ctrl && ctrl.querySelector('button, a, [role="button"]');
      if (target) target.click();
      else if (ctrl) ctrl.click();
    }
    setTimeout(function () { flashSuccess(proxyBtn, 'Added'); }, 550);
    setTimeout(refreshWishlistState, 400);
    setTimeout(refreshWishlistState, 1200);
  }

  function closeMenus() {
    document.querySelectorAll('[data-rc-menu]:not([hidden])').forEach(function (menu) {
      menu.hidden = true;
      var card = menu.closest('.resource-card');
      var k = card && card.querySelector('[data-rc-kebab]');
      if (k) k.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    // Dismiss any open kebab menu when clicking outside it.
    if (!e.target.closest('[data-rc-kebab]') && !e.target.closest('[data-rc-menu]')) {
      closeMenus();
    }

    var kebab = e.target.closest && e.target.closest('[data-rc-kebab]');
    if (kebab) {
      e.preventDefault();
      var card = kebab.closest('.resource-card');
      var menu = card && card.querySelector('[data-rc-menu]');
      var willOpen = menu && menu.hidden;
      closeMenus();
      if (menu && willOpen) {
        menu.hidden = false;
        kebab.setAttribute('aria-expanded', 'true');
        // Interacting with the menu stops carousel autoplay for good.
        var car = kebab.closest('merch-carousel');
        if (car && typeof car.pauseAutoplay === 'function') car.pauseAutoplay();
      }
      return;
    }

    var proxyBtn = e.target.closest && e.target.closest('[data-rc-wishlist-proxy]');
    if (proxyBtn) {
      e.preventDefault();
      proxyWishlist(proxyBtn);
      return;
    }

    var sampleBtn = e.target.closest && e.target.closest('[data-rc-sample]');
    if (sampleBtn) {
      e.preventDefault();
      if (sampleBtn.disabled) return;
      var variantId = sampleBtn.getAttribute('data-sample-variant-id');
      if (!variantId) return;
      sampleBtn.disabled = true;
      startLoading(sampleBtn);
      addSample(variantId, sampleBtn).then(function () {
        sampleBtn.disabled = false;
        sampleBtn.classList.remove('is-loading'); // clears the spinner if the add failed
      });
      return;
    }

    var wrap = e.target.closest && e.target.closest('[data-rc-wishlist]');
    if (!wrap) return;
    var ctrl = wrap.querySelector('.wishlisthero-floating, .wishlist-hero-custom-button');
    if (ctrl && (ctrl === e.target || ctrl.contains(e.target))) return; // heart clicked directly
    e.preventDefault();
    triggerWishlist(wrap);
  });

  // Keyboard support for the wishlist control (role="button").
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenus();
      return;
    }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var wrap = e.target.closest && e.target.closest('[data-rc-wishlist]');
    if (!wrap || wrap !== e.target) return;
    e.preventDefault();
    triggerWishlist(wrap);
  });

  // Close menus on scroll so they never float detached from their card.
  window.addEventListener('scroll', function () {
    if (document.querySelector('[data-rc-menu]:not([hidden])')) closeMenus();
  }, { passive: true });

  // WP-20-11 — initial wishlist state. Run now, then again shortly after to
  // catch WishlistHero hydrating its storage/controls asynchronously, and on
  // cross-tab storage changes.
  refreshWishlistState();
  setTimeout(refreshWishlistState, 800);
  setTimeout(refreshWishlistState, 2000);
  window.addEventListener('storage', function (e) {
    if (!e.key || /wishlist|swym|wlh/i.test(e.key)) refreshWishlistState();
  });
  document.addEventListener('wishlisthero:updated', refreshWishlistState);
})();
